import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import BookSuccess from "@/pages/BookSuccess";
import CommercialQuote from "@/pages/CommercialQuote";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/book/success" element={<BookSuccess />} />
          <Route path="/commercial-quote" element={<CommercialQuote />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
